import { render, staticRenderFns } from "./BisaDialog.vue?vue&type=template&id=721dcf32"
import script from "./BisaDialog.vue?vue&type=script&lang=js"
export * from "./BisaDialog.vue?vue&type=script&lang=js"
import style0 from "./BisaDialog.vue?vue&type=style&index=0&id=721dcf32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports